// ES lang
export default {
    username: "Nombre de usuario",
    //   last_name: 'Nombres',
    password: 'Contraseña',
    "Enter password": "Ingresa contraseña",
    repeat_password: 'Repetir contraseña',
    email_or_username: 'Usuario',
    email: 'Correo electrónico',
    name: 'Nombre',
    first_name: 'Nombres',
    last_name: 'Apellidos',
    gender: 'Género',
    birth_date: 'Fecha de nacimiento',
    document_type: 'Tipo de documento',
    document_number: 'Número de documento',
    institute: 'Institución',
    position: 'Cargo',
    loading: 'Cargando',
    login: 'Iniciar sesión',
    copyright: 'Todos los derechos reservados',
    optional: 'Opcional',
    description: 'Descripción',
    nit: 'NIT',
    category: 'Categoría',
    age_range: 'Rango de edad',
    third_parties: 'Cliente',
    delete: 'Eliminar',
    submit: 'Enviar',
    save: 'Guardar',
    create: 'Crear',
    update: 'Actualizar',
    cancel: 'Cancelar',
    icon: 'Ícono',
    order: 'Orden',
    subject: 'Asunto',
    body: 'Cuerpo',
    city: 'Ciudad',
    blood_type: 'Tipo de Sangre',
    place: 'Nombre del lugar',
    registration_form: 'Formulario de registro',
    sign_up: 'Registrar',
    warehouse: 'Bodega',
    fill_the_required_fields: 'Complete los campos requeridos.',
    successful_registration: 'Perfil creado satisfactoriamente',
    edit: 'Editar',
    actions: 'Acciones',
    parameters: 'Parámetros',
    parameter: 'Parámetro',
    "Logout": "Salir",
    forms: {
        correct_form_errors: 'Errores'
    },
    validation: {
        alpha: "El campo {attribute} solo debe contener letras",
        alpha_dash: "El campo {attribute} solo debe contener letras, números y guiones",
        alpha_num: "El campo {attribute} solo debe contener letras y números",
        alpha_spaces: "El campo {attribute} solo debe contener letras y espacios",
        between: "El campo {attribute} debe estar entre {min} y {max}",
        confirmed: "El campo {attribute} no coincide",
        digits: "El campo {attribute} debe ser numérico y contener exactamente {length} dígitos",
        dimensions: "El campo {attribute} debe ser de {width} píxeles por {height} píxeles",
        email: "El campo {attribute} debe ser un correo electrónico válido",
        excluded: "El campo {attribute} debe ser un valor válido",
        ext: "El campo {attribute} debe ser un archivo válido",
        image: "El campo {attribute} debe ser una imagen",
        integer: "El campo {attribute} debe ser un entero",
        length: "El largo del campo {attribute} debe ser {length}",
        max: "El campo {attribute} no debe ser mayor a {length} caracteres",
        max_value: "El campo {attribute} debe de ser {max} o menor",
        mimes: "El campo {attribute} debe ser un tipo de archivo válido",
        min: "El campo {attribute} debe tener al menos {length} caracteres",
        min_value: "El campo {attribute} debe ser {min} o superior",
        numeric: "El campo {attribute} debe contener solo caracteres numéricos",
        oneOf: "El campo {attribute} debe ser un valor válido",
        regex: "El formato del campo {attribute} no es válido",
        required: "El campo {attribute} es obligatorio",
        required_if: "El campo {attribute} es obligatorio",
        size: "El campo {attribute} debe ser menor a {size}KB",
        sameAsPassword: "Las contraseñas deben ser idénticas",
        minLength: "El campo {attribute} debe ser {min} o superior",

    },
    expired_session: 'Tu sesión ha expirado, inicia sesión nuevamente',
    login_required: 'Sesión finalizada',
    login_section: {
        init_msg: "Ingresa nombre de usuario y contraseña para acceder al sitio.",
        forgot_your_password: "¿Olvidaste tu contraseña?",
        dont_have_an_account: "¿No tienes una cuenta?",
        sign_up: "Regístrate"
    },
    company_info_section: {
        company_name: 'Nombre de la compañía',
        phone_number: 'Número de teléfono',
        primary_color: 'Color primario',
        whatsapp_number: 'Whatsapp',
        contact_email: 'Email de contacto',
        support_email: 'Email de soporte',
        instagram_name: 'Nombre usuario Instagram',
        instagram_url: 'URL Instagram',
        facebook_name: 'Nombre Facebook',
        facebook_url: 'URL Facebook',
        site_url_back: 'URL sitio (back)',
        site_url_front: 'URL sitio (front)',
    },
    projects: {
        page_title: 'Proyectos',
        name: {
            name: 'Nombre proyecto'
        },
        comments: {
            name: 'Comentarios'
        }
    },
    datatable: {
        recordsperpage: 'Registros por página',
        filter: 'Filtro',
        typetosearch: 'Buscar',
        clear: 'Limpiar',
        loading: 'Cargando',
        showing: 'Mostrando',
        of: 'de',
        totalrows: 'registros totales',
        empty_filtered_text: 'No se encontraron Resultados',
    },
    calendar: {
        days: {
            Mon: 'Lun',
            Tue: 'Mar',
            Wed: 'Mié',
            Thu: 'Jue',
            Fri: 'Vie',
            Sat: 'Sáb',
            Sun: 'Dom',
            Monday: 'Lunes',
            Tuesday: 'Martes',
            Wednesday: 'Miércoles',
            Thursday: 'Jueves',
            Friday: 'Viernes',
            Saturday: 'Sábado',
            Sunday: 'Domingo'
        },
        months: {
            January: 'Enero',
            February: 'Febrero',
            March: 'Marzo',
            April: 'Abril',
            May: 'Mayo',
            June: 'Junio',
            July: 'Julio',
            August: 'Agosto',
            September: 'Septiembre',
            October: 'Octubre',
            November: 'Noviembre',
            December: 'Diciembre'
        }
    }
}